import Home from "pages/Home";
import SharedLayout from "utils/SharedLayout";
import { useTranslation } from "react-i18next";
import NotificationManager from "pages/notification_manager/NotificationManager";
import Profile from "pages/profile/Profile";
import HelpSupport from "pages/help_support/HelpSupport";
import ChangePassword from "pages/auth/ChangePassword";
import Sidebar from "components/sidebar/Sidebar";
import Login from "pages/Login";
import AuthorizationRoute from "utils/AuthorizationRoute";
import DriverManager from "pages/driver_manager/Driver";
import Transaction from "pages/transection_manager/Transaction";
import EarningManager from "pages/earning_manager/Earning";
import ServiceManager from "pages/service_manager/ServiceManager";
import Tracking from "pages/service_manager/Tracking";
import AddDriver from "pages/driver_manager/AddDriver";
import FeedbackDashboard from "pages/feedback_manager/Feedback";
import ViewServiceDetails from "pages/service_manager/ViewDetails";
import SPDriverAvailabilityCalendar from "pages/driver_manager/availabilityCalendar";
import VehicleManager from "pages/vehicle_manager/VehicleManager";
import ServicePriceManager from "pages/service_price_manager/ServicePriceManager"
import ViewService from "pages/service_price_manager/ViewService"
import AnnouncementManager from "pages/announcement_manager/AnnouncementManager"
import ViewAnnouncement from "pages/announcement_manager/ViewAnnouncement"

const UseChange = ({ data }) => {
  const { t } = useTranslation();
  return t(data);
};

const AdminRoutes = {
  // All common routes
  path: "/",
  element: <SharedLayout type={<Sidebar />} />,
  children: [
    {
      path: "/dashboard",
      element: <Home />,
      name: <UseChange data="NAV_DASHBOARD" />,
    },
    {
      path: "/login",
      element: <Login />,
    },


    {
      path: "/driver-manager",
      element: (
        <AuthorizationRoute>
          <DriverManager />
        </AuthorizationRoute>
      ),
      name: <UseChange data="DRIVER_MANAGER" />,
    },

    {
      path: "/driver-manager/add",
      element: (
        <AuthorizationRoute>
          <AddDriver />
        </AuthorizationRoute>
      ),
      name: <UseChange data="ADD_DRIVER" />,
    }, 
    {
      path: "/driver-manager/edit",
      element: (
        <AuthorizationRoute>
          <AddDriver />
        </AuthorizationRoute>
      ),
      name: <UseChange data="EDIT_DRIVER" />,
    },
    {
      path: "/driver-manager/view",
      element: (
        <AuthorizationRoute>
          <AddDriver />
        </AuthorizationRoute>
      ),
      name: <UseChange data="VIEW_DRIVER" />,
    }, 
    {
      path: "/driver-manager/availability-calendar",
      element: (
        <AuthorizationRoute>
          <SPDriverAvailabilityCalendar />
        </AuthorizationRoute>
      ),
      name: <UseChange data="VIEW_DRIVER" />,
    },   
    

    {
      path: "/vehicle-manager",
      element: (
        <AuthorizationRoute>
          <VehicleManager />
        </AuthorizationRoute>
      ),
      name: <UseChange data="VEHICLE_MANAGER" />,
    },

    {
      path: "/service-price-manager",
      element: (
        <AuthorizationRoute>
          <ServicePriceManager />
        </AuthorizationRoute>
      ),
      name: <UseChange data="SERVICE_PRICE_MANAGER" />,
    },

    {
      path: "/service-price-manager/edit",
      element: (
        <AuthorizationRoute>
          <ViewService />
        </AuthorizationRoute>
      ),
      name: <UseChange data="EDIT_SERVICE_PRICE_MANAGER" />,
    },

    {
      path: "/service-price-manager/view",
      element: (
        <AuthorizationRoute>
          <ViewService />
        </AuthorizationRoute>
      ),
      name: <UseChange data="VIEW_SERVICE_PRICE_MANAGER" />,
    },

    {
      path: "/announcement-manager",
      element: (
        <AuthorizationRoute>
          <AnnouncementManager />
        </AuthorizationRoute>
      ),
      name: <UseChange data="SERVICE_PRICE_MANAGER" />,
    },
    {
      path: "/announcement-manager/view",
      element: (
        <AuthorizationRoute>
          <ViewAnnouncement />
        </AuthorizationRoute>
      ),
      name: <UseChange data="VIEW_SERVICE_PRICE_MANAGER" />,
    },


    {
      path: "/notification-manager",
      element: (
        <AuthorizationRoute>
          {" "}
          <NotificationManager />
        </AuthorizationRoute>
      ),
      name: <UseChange data="NOTIFICATION_MANAGER" />,
    },


    {
      path: "/view-profile",
      element: <Profile />,
      name: <UseChange data="VIEW_PROFILE" />,
    },
    {
      path: "/help-and-support",
      element: <HelpSupport />,
      name: <UseChange data="HELP_SUPPORT" />,
    },

    {
      path: "/change-password",
      element: <ChangePassword />,
      name: <UseChange data="NAV_EARNING_MANAGER" />,
    },


   
    
   
    {
      path: "/transaction-manager",
      element: (
        <AuthorizationRoute>
          <Transaction />
        </AuthorizationRoute>
      ),
      name: <UseChange data="SUBSCRIPTION_MANAGER" />,
    },

    {
      path: "/earning-manager",
      element: (
        <AuthorizationRoute>
          <EarningManager />
        </AuthorizationRoute>
      ),
      name: <UseChange data="EARNING_MANAGER" />,
    },


      {
      path: "/feedback-manager",
      element: (
        <AuthorizationRoute>
          <FeedbackDashboard />
        </AuthorizationRoute>
      ),
      name: <UseChange data="FEEDBACK_MANAGER" />,
    },

    {
      path: "/help-and-support",
      element: (
        <AuthorizationRoute>
          <HelpSupport />
        </AuthorizationRoute>
      ),
      name: <UseChange data="HELP_AND_SUPPORT" />,
    },

    {   
      path: "/service-monitoring",
      element: (
        <AuthorizationRoute>
          <ServiceManager />
        </AuthorizationRoute>
      ),
      name: <UseChange data="SERVICE_MANAGER" />,
    },



       {
      path: "/track-services/view/:id",
      element: (
        <AuthorizationRoute>
          <ViewServiceDetails />
        </AuthorizationRoute>
      ),
      name: <UseChange data="VIEW_SERVICE_MANAGER" />,
    },




     {
      path: "/live-tracking",
      element: (
        <AuthorizationRoute>
          <Tracking />
        </AuthorizationRoute>
      ),
      name: <UseChange data="LIVE_TRACKING" />,
    },


    {
      path: "/",
      element: <Home />,
      name: <UseChange data="NAV_DASHBOARD" />,
    },
  ],
};

export default AdminRoutes;
